<template>
<div>人员操作记录</div>
</template>

<script>
export default {
  name: 'controlsRecords'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/controlsRecords.vue